import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';

var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
      'x-api-key':localStorage.getItem('Filename')
    })
  };
}

@Injectable({
  providedIn: 'root'
})
export class HikiateStatusService {


  searchdropdown3UrlApi = this.environment.Mastersearchdropdown3apiUrlrest1;
  searchdropdown3UrlApi1 = this.environment.Mastersearchdropdown3apiUrlrest2;

  namcHs = '/getNamcHs/{proxy+}'
  familyByNamcHs = '/getFamilyByNamcHs/{proxy+}'
  family ='/getfamilyHikiStsScrn/{proxy+}'
  hikiateStatusHs = '/getHikiateStatusHs/{proxy+}'
  gridData = '/getHikiateStatusGrid/{proxy+}'

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }

  //namc
  getNamcHs(): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    const url = this.environment.Mastersearchdropdown3apiUrlrest2 + this.namcHs+'?screenNo=NBPC_9996'+'&fileName=' +fileName
    return this.http.get(url, httpOptions)
      .pipe(map((res: any) => res), catchError(this.error))
  }

  //familybynamc
  getFamilyHs(namc): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let hikiateparams = new HttpParams().set('namcId',namc)
    // let API_URL = `${this.searchdropdown3UrlApi}/${this.familyByNamcHs}`;
    const url = this.environment.Mastersearchdropdown3apiUrlrest1+ this.familyByNamcHs + '?namcId=' + namc+'&screenNo=NBPC_9996'+'&fileName=' +fileName
    return this.http.get(url, httpOptions)
      .pipe(map((res: any) => res), catchError(this.error))
  }
  
//family
  getFamily(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    const url = this.environment.Mastersearchdropdown3apiUrlrest2 + this.family+'?screenNo=NBPC_9996'+'&fileName=' +fileName
    return this.http.get(url, httpOptions)
      .pipe(map((res: any) => res), catchError(this.error))
  }

  //hikiate status
  getHikiateStatusHs(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let API_URL = `${this.searchdropdown3UrlApi}/${this.hikiateStatusHs}`;
    const url = this.environment.Mastersearchdropdown3apiUrlrest2 + this.hikiateStatusHs+'?screenNo=NBPC_9996'+'&fileName=' +fileName
    return this.http.get(url, httpOptions)
      .pipe(map((res: any) => res), catchError(this.error))
  }



  //grid data
  getHikiateStatusGrid(gridData): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let gridParams = new HttpParams().set('namc', gridData.namc)
    //   .append('family', gridData.family)
    //   .append('hikiate', gridData.hikiateStatus)
    //   .append('effInDt', gridData.effectiveInDate)
    //   .append('effOutDt', gridData.effectiveOutDate)
    //   .append('option', gridData.option)
    let API_URL = this.environment.MastergridapiUrl + this.gridData + '?namc=' + gridData.namc +
      '&family=' + gridData.family + '&hikiate=' + gridData.hikiateStatus + '&effInDt=' + gridData.effectiveInDate +
      '&effOutDt=' + gridData.effectiveOutDate + '&option=' + gridData.option+'&screenNo=NBPC_9996'+'&fileName=' +fileName
    return this.http.get(API_URL,httpOptions)
      .pipe(catchError(this.error)
      )
  }



  // Handle Errors 
  error(error: HttpErrorResponse) {
    let errorMessage:any= '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.status;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }


  

}
